import * as tslib_1 from "tslib";
import { SigninService } from './signin.service';
import { Router } from "@angular/router";
import { AfterViewInit, NgZone, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AuthService } from '../auth.service';
var SigninComponent = /** @class */ (function () {
    function SigninComponent(router, signInService, ngZone, authService) {
        this.router = router;
        this.signInService = signInService;
        this.ngZone = ngZone;
        this.authService = authService;
    }
    SigninComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.authCheckPromise = this.authService.isAuthenticated();
        // Shared-domain cookies (CSCC or prior payroll login) → skip Google login.
        this.authCheckPromise.then(function (authenticated) {
            if (authenticated) {
                _this.router.navigate(['/']);
            }
        });
    };
    SigninComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        // Wait for the same auth check; only init Google when unauthenticated.
        (this.authCheckPromise || this.authService.isAuthenticated()).then(function (authenticated) {
            if (authenticated) {
                return;
            }
            _this.initializeTokenClient();
            _this.initializeGoogleSignIn();
        });
    };
    SigninComponent.prototype.initializeGoogleSignIn = function () {
        if (google && google.accounts && google.accounts.id) {
            google.accounts.id.initialize({
                client_id: environment.googleClientId,
                callback: this.handleCredentialResponse.bind(this),
            });
        }
        else {
            console.error('Google accounts library is not loaded correctly.');
        }
    };
    SigninComponent.prototype.handleCredentialResponse = function (response) {
        this.tokenClient.requestAccessToken();
    };
    SigninComponent.prototype.initializeTokenClient = function () {
        var _this = this;
        if (google && google.accounts && google.accounts.oauth2) {
            this.tokenClient = google.accounts.oauth2.initTokenClient({
                client_id: environment.googleClientId,
                scope: 'email',
                callback: function (tokenResponse) {
                    var accessToken = tokenResponse.access_token;
                    _this.handleGoogleSignIn(accessToken);
                }
            }),
                console.log('OAuth Token Client Initialized');
        }
        else {
            console.error('Google OAuth library is not loaded.');
        }
    };
    SigninComponent.prototype.onSignInClick = function () {
        if (google && google.accounts && google.accounts.id) {
            google.accounts.id.prompt(); // Show the Google sign-in popup manually
        }
        else {
            console.error('Google Identity Services library is not loaded correctly.');
        }
    };
    SigninComponent.prototype.handleGoogleSignIn = function (token) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var data, tokenResponse;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        data = { accessToken: token, source: "payroll_dashboard" };
                        return [4 /*yield*/, this.signInService.login(data).toPromise()];
                    case 1:
                        tokenResponse = _a.sent();
                        this.authService.establishSession(tokenResponse.token, tokenResponse.permissions);
                        this.authService.setUserDetails(tokenResponse);
                        this.ngZone.run(function () {
                            _this.router.navigate(['/']);
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    return SigninComponent;
}());
export { SigninComponent };
